import React from "react";
import phone from "../../assets/phone.png";
import "./index.css";
import { Link } from "react-router-dom";

const Control = () => {
  return (
    <div className="section noPadBot flex flexRow gap alignCenter">
      <div className="container-lg flex alignCenter flexCol">
        <div className="flex flexRow space alignCenter controlSection">
          <div className="flex flexCol alignLeft">
            <h2>Control total de tu alarma directo desde tu teléfono</h2>
            <p>
              La aplicación inteligente ADT te permite ver las cámaras en vivo, escuchar todo lo que pasa, configurar, disparar remotamente y controlar tu alarma desde cualquier lugar.
            </p>
            <Link to="/cotizador" className="btn">
              Cotizar Alarma
            </Link>
          </div>
          <img src={phone} alt="App" />

        </div>
      </div>
    </div>
  );
};

export default Control;
